import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles({ name: 'RadioCard' })((theme) => ({
  radioCard: {
    padding: theme.spacing(1),
    margin: 0,
    marginRight: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: '5px',
    [theme.breakpoints.down('lg')]: {
      marginBottom: theme.spacing(1),
    },
  },
  activeRadioCard: {
    backgroundColor: theme.palette.primary.main + '1A',
    border: `1px solid ${theme.palette.primary.main}`,
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
  },
  icon: {
    marginRight: theme.spacing(1),
    color: theme.palette.text.secondary,
  },
  activeText: {
    color: theme.palette.primary.main,
  },
}));

export default useStyles;
